export const en = {
    'low-sum-hint': 'Top up the shared account to launch your ad campaigns',
    'wallet-button': 'Shared account'
};
